import React, { useEffect, useState } from 'react';
import styles from './MembersList.module.scss';
import SearchInput from 'component/atom/forms/input/searchInput/SearchInput';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useFetch } from 'hooks/useFetch';
import { groupEndpoints } from 'hooks/endpoints';
import Loader from 'component/atom/loader/Loader';
import ConfirmationModal from 'component/hoc/success-modal/ConfirmationModal';
import { useDelete } from 'hooks/useDelete';
import { useToast } from 'app-context/toasterContext/ToastContext';

const MembersList = ({ groupId }) => {
  const [searchKey, setSearchKey] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(false);
  const toast = useToast();
  const { mutate: deleteMember, isPending: isPendingDelete } = useDelete();

  const getNameParts = (fullName = '') => {
    const parts = String(fullName).trim().split(/\s+/).filter(Boolean);
    const firstName = parts[0] || '';
    const lastName = parts.length > 1 ? parts[parts.length - 1] : '';
    return { firstName, lastName };
  };

  const {
    data: members,
    refetch: refetchMembers,
    isLoading,
    isFetching,
  } = useFetch(
    ['members', groupId],
    groupEndpoints.fetchGroupMembers(),
    {
      enabled: !!groupId,
    },
    {
      userGroupId: groupId,
      searchKey: !searchKey ? '' : searchKey,
    },
  );

  const handleDelete = () => {
    deleteMember(
      {
        url: groupEndpoints.deleteGroupMember(selectedMember),
      },
      {
        onSuccess: (e) => {
          toast.open('Member Removed', 'add');
          refetchMembers();
          setShowDeleteModal(false);
          setSelectedMember('');
        },
      },
    );
  };

  useEffect(() => {
    refetchMembers();
  }, [searchKey]);

  return (
    <div className={styles['members-list-container']}>
      <SearchInput
        placeholder='Search by name'
        value={searchKey}
        onChange={(e, val) => setSearchKey(val)}
      />
      <div className={styles['members-list']}>
        {isLoading || isFetching ? (
          <Loader isComponent />
        ) : (
          members?.data.map((item) => (
            <div className={styles['member-item']} key={item?.userId}>
              <div className={styles['member-info']}>
                <div className={styles['image-placeholder']}>
                  {(() => {
                    const { firstName, lastName } = getNameParts(item?.name);
                    const firstInitial = firstName ? firstName.charAt(0) : '';
                    const lastInitial = lastName ? lastName.charAt(0) : '';

                    return (
                      <p>
                        {firstInitial}
                        {lastInitial}
                      </p>
                    );
                  })()}
                </div>
                <div className={styles['title-container']}>
                  <p className={styles['title']}>{item?.name}</p>
                  <p className={styles['email']}>{item?.email}</p>
                </div>
              </div>
              <SvgWithBranding
                type='delete2'
                className={styles['delete-btn']}
                onClick={() => {
                  setShowDeleteModal(true);
                  setSelectedMember(item?.userId);
                }}
              />
            </div>
          ))
        )}
      </div>
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onSubmit={handleDelete}
        closeOnSubmit={true}
        onApproveButton={{ text: 'Remove User' }}
        text='Remove User'
        subText='Are you sure you want to remove this user?'
        isLoading={isPendingDelete}
      />
    </div>
  );
};

export default MembersList;
